import { Button } from "reactstrap";
import styles from "../../styles/public/booking-button.module.css";

const BookingButton = ({ children, variant = "primary", onClick, disabled = false, type = "button" }) => {
  return (
    <Button
      type={type}
      className={`${styles["booking-button"]} ${
        variant === "primary" ? styles["booking-button--primary"] : styles["booking-button--secondary"]
      } ${disabled ? styles["disabled"] : ""}`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </Button>
  );
};

export default BookingButton;